import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation } from 'swiper';
import tractor1 from '../../images/tractor-1.jpg'
import tractor2 from '../../images/tractor-2.jpg'
import tractor3 from '../../images/tractor-3.jpg'
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import TractorCard from './TractorCard';
import { useQuery } from 'react-query'
import { getTractorsByCategoryApi } from '../../api'


SwiperCore.use([Navigation]);

const swiperParams = {
    slidesPerView: 1.25,
    centeredSlides: false,
    loop: false,
    spaceBetween: 20,
    shouldSwiperUpdate: true,
    rebuildOnUpdate: true,
    breakpoints: {
        900: {
            slidesPerView: 4.5,
        },
        600: {
            slidesPerView: 3.2,
        },
    },
}

function TractorSlider({ category, lowBudget, highBudget }) {
    return (
        <div className="">
            <Swiper
                {...swiperParams}
                navigation={true}
            >
                <SwiperSlide key="1">
                    <TractorCard imageUrl={tractor1} />
                </SwiperSlide>
                <SwiperSlide key="2">
                    <TractorCard imageUrl={tractor2} />
                </SwiperSlide>
                <SwiperSlide key="3">
                    <TractorCard imageUrl={tractor3} />
                </SwiperSlide>
                <SwiperSlide key="4">
                    <TractorCard imageUrl={tractor1} />
                </SwiperSlide>
                <SwiperSlide key="5">
                    <TractorCard imageUrl={tractor3} />
                </SwiperSlide>
                <SwiperSlide key="6">
                    <TractorCard imageUrl={tractor2} />
                </SwiperSlide>
                <SwiperSlide key="7">
                    <TractorCard imageUrl={tractor3} />
                </SwiperSlide>
                <SwiperSlide key="8">
                    <TractorCard imageUrl={tractor1} />
                </SwiperSlide>
                <SwiperSlide key="9">
                    <TractorCard imageUrl={tractor2} />
                </SwiperSlide>
            </Swiper>
        </div>
    );
}

export default TractorSlider;



//////////////////////////////////////////
// Looping over data recevived from API //
//////////////////////////////////////////

// const { data, status, error } = useQuery(['tractors', category, lowBudget, highBudget], getTractorsByCategoryApi)

// return (
//     <div className="">
//         {(status === "success" && data.error === "NA") && (
//             <Swiper
//                 {...swiperParams}
//                 navigation={true}
//                 // onSlideChange={() => console.log('slide change')}
//                 // onSwiper={(swiper) => console.log(swiper)}
//             >
//                 {data.results.map((value, key) => (
//                     <SwiperSlide key={key}>
//                         <TractorCard data={value} />
//                     </SwiperSlide>
//                 ))}

//             </Swiper>
//         )}
//     </div>
// );